import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface FieldGroupProps {
  label?: string;
  children: React.ReactNode;
  spacing?: number;
}

/**
 * A reusable component for grouping related form fields side-by-side
 * with optional label and helper text
 */
export const FieldGroup: React.FC<FieldGroupProps> = ({ label, children, spacing = 2 }) => {
  const theme = useTheme();

  return (
    <Box>
      {label && (
        <Typography
          variant="body2"
          sx={{
            mb: 1,
            fontWeight: 600,
            color: theme.palette.text.secondary,
            fontSize: '0.875rem',
          }}
        >
          {label}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          gap: spacing,
          alignItems: 'flex-start',
          flexWrap: 'wrap',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default FieldGroup;
